module.exports = __webpack_public_path__ + "img/1200x450_Zeppelin-Baggerboerse_v2.db5e52dc.jpg";